import { render, staticRenderFns } from "./LookUp.vue?vue&type=template&id=2ccd05f1&scoped=true"
import script from "./LookUp.vue?vue&type=script&lang=js"
export * from "./LookUp.vue?vue&type=script&lang=js"
import style0 from "./LookUp.vue?vue&type=style&index=0&id=2ccd05f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd05f1",
  null
  
)

export default component.exports